import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import LogoGym from "../../Picture/logoKekes.png";
import PengeluaranGym1 from "../PengeluaranGym1";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const InventoryGym2=(props)=>{
    const url = props.url;
    const [pilihan,setPilihan]=useState("pengeluaran");
    const navigate = useNavigate();
    const location = useLocation();
    const [namaKop,setNamaKop]=useState("Pengeluaran");
    
    // function Klik Pilihan
    const KlikPilihan=(value)=>{
        if(value ==="pengeluaran"){
navigate("/gym2/inventory");
setNamaKop("Pengeluaran");
}
else if(value === "rekapan"){
navigate("/gym2/inventory/rekapan");
setNamaKop("Rekapan");
}
else if(value ==="personalTrainer"){
    navigate("/gym2/inventory/personalTrainer");
    setNamaKop("Personal Trainer");
}
        
        setPilihan(value);
        
    }
    // use effect location
     useEffect(() => {
    if (location.pathname.includes("rekapan")) {
      setPilihan("rekapan");
    } else if (location.pathname.includes("personalTrainer")) {
      setPilihan("personalTrainer");
    } else {
      setPilihan("pengeluaran");
    }
  }, [location.pathname]);

  // use effect
    useEffect(()=>{
        fetch(url + "/?op=cekSession", {
            credentials: "include", 
          })
          .then((response)=>response.json())
          .then((json)=>{
           
          if (json === "kosong") {
                navigate("/", { replace: true });
              }else if(json ==="gym1"){
    navigate("/gym1", { replace: true });
              }else if(json ==="owner"){
    navigate("/owner", { replace: true });
              }
          })
        },[])
return(
    <div className={style.containerAll}>
<div className={style.containerHeader}>
    <div onClick={(()=>navigate("/gym2"))} className={style.divLogo}>
<img src={LogoGym}/>
    </div>
<div className={style.divJudul}>
{namaKop} Inventory Gym
</div>
<div className={style.containerPilihan}>
<div style={{borderBottom:pilihan==="pengeluaran"?"solid 2px blue":""}} onClick={()=>KlikPilihan("pengeluaran")} className={style.divPilihan}>
Pengeluaran
</div>
<div style={{borderBottom:pilihan==="rekapan"?"solid 2px blue":""}} onClick={()=>KlikPilihan("rekapan")} className={style.divPilihan}>
Rekapan
</div>
<div style={{borderBottom:pilihan==="personalTrainer"?"solid 2px blue":""}} onClick={()=>KlikPilihan("personalTrainer")} className={style.divPilihan}>
Personal Trainer
</div>
</div>
</div>
<div className={style.containerIsi}>
<Outlet/>
</div>
    </div>
)
}
export default InventoryGym2;